import { TIconProps } from '@/common/components/Icons/Icon';
import { IMenhirBenefitSlug } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import { TOrderCategorySlug } from '@/common/integrations/menhir/employee/orders/orders.types';
import { benefitIconMapper } from '@/common/utils/benefits/benefit-utils';
import { IconSeedling, themeVars } from '@coverflex-tech/hypernova';

interface IProps {
  benefit: IMenhirBenefitSlug | Extract<TOrderCategorySlug, 'health'>;
  color?: string;
  className?: string;
}

export const BenefitIcon = ({ benefit, color, className }: IProps) => {
  const icon = benefitIconMapper[benefit] ?? <IconSeedling />;
  return (
    <icon.type
      {...(icon.props as TIconProps)}
      color={color ?? themeVars.color.semantic.text.accentSecondary10}
      className={className}
    />
  );
};
